export enum enumTypeView {
  ISF = 'ISF',
  COMPANY = 'COMPANY',
}
